import alerts from "./alerts";
import companies from "./companies";
import company from "./company";
import crops from "./crops";
import guidedTour from "./guidedTour";
import missionMonitoring from "./missionMonitoring";
import { persistCombineReducers } from "redux-persist";
import requests from "./requests";
import resultMap from "./resultMap";
import sites from "./sites";
import storage from "redux-persist/lib/storage";
import traits from "./traits";
import user from "./user";
import users from "./users";

const persistConfig = { key: "root", storage, whitelist: ["user"] };

// eslint-disable-next-line import/no-anonymous-default-export
export default () =>
  persistCombineReducers(persistConfig, {
    alerts,
    companies,
    company,
    sites,
    traits,
    resultMap,
    crops,
    guidedTour,
    missionMonitoring,
    requests,
    user,
    users,
  });
